export default function bombsite(value) {
  return value || '∅'
}
